import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import fetchTimeout from 'fetch-timeout';
import backgroundImage from '../assets/images/score/bg.png'
// import backgroundImage from '../assets/images/score/bg.jpg'
// import yellowDrone from '../assets/images/score/yellow.png';
// import redDrone from '../assets/images/score/red.png';
// import blueDrone from '../assets/images/score/blue.png';
import Cookies from 'universal-cookie';
import domtoimage from 'dom-to-image-improved';
import { saveAs } from 'file-saver';

// import yellowQrcode from '../assets/images/score/qrcode-yellow.png';
// import redQrcode from '../assets/images/score/qrcode-red.png';
// import blueQrcode from '../assets/images/score/qrcode-blue.png';

// import continueImage from '../assets/images/reward/continue.png'
// import downloadImage from '../assets/images/score/download.png'
import introBtn from '../assets/images/score/intro-btn.png'

import constant from '../assets/const.json';

// const drones = [ yellowDrone, redDrone, blueDrone ]
// const qrcodes = [ yellowQrcode, redQrcode, blueQrcode ]

const cookies = new Cookies();
const APP_NAME_PREFIX = "Drone-Game_";

class Score extends Component {

    btnSound = './sounds/button_sound.mp3';

    constructor(props) {
        super(props);
        this.state = {
            score: this.props.location.state.score,
            maxScore: 1000,
            selectedIndex: this.props.location.state.selectedIndex,
            // qrcode: qrcodes[this.props.location.state.selectedIndex],
            // drone: drones[this.props.location.state.selectedIndex]
        };
    }

    componentDidMount() {
        let uid = cookies.get('uid');
        let topScore = cookies.get('drone_top_score');
        if (topScore === null || topScore === undefined) {
            topScore = 'NA';
            console.log('[Params] top score is : NA');
        }
        this.setState({
            maxScore: topScore
        });
        let score = this.state.score;
        console.log('[Params] get uid from cookie = ' + uid);
        if (uid === null || uid === undefined) {
            uid = '';
            console.log('[Params] generate random uuid : ' + uid);
        }
        console.log('[Params] drone_score = ' + score);
        this.postDataToServer(uid, score);
    }

    getRequestBody(uid, score) {
        return {
            uid: uid,
            drone_score: score,
            drone_color: this.state.selectedIndex,
            action: 'result'
        };
    }

    postDataToServer(uid, score) {
        let apiPath = constant.WEB_API_PATH;
		fetchTimeout(apiPath, {
            headers: {
                'Content-Type': 'application/json'
            },
			method: 'POST',
			body: JSON.stringify(this.getRequestBody(uid, score))
        }, 5 * 1000, '[WebAPI] Timeout')
        .then(response => response.json())
		.then(data => {
			if (data.success) {
                // call api ok
                console.log('[WebAPI] success');
            } else {
                // call api failed
                console.log('[WebAPI] failed');
            }
		}).catch(e => {
			console.log('[WebAPI] ' + e);
		});
    }
    
    goToIntroPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './intro',
            state: {}
        });
    }

    goToRewardPage() {
        this.playBtnSound();
        this.props.history.push({
            pathname: './reward',
            state: {}
        });
    };

    playBtnSound() {
        let btnAudio = new Audio(this.btnSound);
        btnAudio.play();
    }

    downloadResultImage() {
        let element = document.getElementById('result-div');
        let scale = constant.DESIRED_RATIO_WIDTH / element.clientWidth;
        domtoimage.toBlob(element, {
            width: constant.DESIRED_RATIO_WIDTH,
            height: constant.DESIRED_RATIO_HEIGHT,
            style: {
                transform: 'scale(' + scale + ')',
                transformOrigin: 'top left'
            }
        })
        .then(function (blob) {
            const date = new Date();
            const mm = date.getMonth() + 1;
            const dd = date.getDate()
            const month = (mm > 9 ? '' : '0') + mm
            const day = (dd > 9 ? '' : '0') + dd
            const year = date.getFullYear();
            saveAs(blob, APP_NAME_PREFIX + year + month + day + '.png');
        });
    }

    render() {
        return (
            <div className='page-root-div'>
                <div id='result-div' style={{ position: 'absolute', width: '100%', height: '100%', left: '0px', top: '0px' }}>
                    <img alt='' src={backgroundImage} style={{ width: '100%', height: '100%', overflow: 'hidden', objectFit: 'cover', position: 'absolute' }}/>
                    {/* <img alt='' src={this.state.drone} style={{ width: '28%', position: 'absolute', left: '56%', top: '31%' }}></img>
                    <img alt='' src={this.state.qrcode} style={{ width: '11%', position: 'absolute', left: '36%', top: '55%' }}></img> */}
                    <div style={{ position: 'absolute', right: '43%', top: '43%', width: '6%', height: '6%', color: 'white' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="white" >{this.state.score}</text>
                        </svg>
                    </div>
                    {/* <div style={{ position: 'absolute', right: '63%', top: '8.5%', width: '6%', height: '50%', color: 'white' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="white" >{this.state.score}</text>
                        </svg>
                    </div> */}
                    <div style={{ position: 'absolute', right: '39%', top: '54.5%', width: '6%', height: '6%', color: '#086940' }}>
                        <svg width='100%' height='100%' viewBox='0 0 500 75' preserveAspectRatio="xMinYMid meet" style={{ position: 'absolute' }} xmlns="http://www.w3.org/2000/svg" xmlnsXlink='http://www.w3.org/1999/xlink'>
                            <text x="50%" y ="50%" dominantBaseline="middle" textAnchor="middle" fontSize="200" fill="#086940" >{this.state.maxScore}</text>
                        </svg>
                    </div>
                </div>
                {/* <img className='press-btn' alt='' src={continueImage} style={{ height: '12%', bottom: '9%', left: '21%', position: 'absolute', background: 'transparent' }} onClick={this.goToRewardPage.bind(this)}/>
                <img className='press-btn' alt='' src={downloadImage} style={{ height: '12%', bottom: '9%', left: '59%', position: 'absolute', background: 'transparent' }} onClick={this.downloadResultImage.bind(this)}/> */}
                <img className='press-btn' alt='' src={introBtn} style={{ height: '12%', bottom: '9%', left: '40%', position: 'absolute', background: 'transparent' }} onClick={this.goToIntroPage.bind(this)}/>
            </div>
        )
    }
}

export default withRouter(Score);
